import reduceReducers from "reduce-reducers";
import { getApiReducer } from "redux-store/api-sagas";
import { reduceById, updateById } from "redux-store/reducers";

import {
  EDIT_APPLICATION_SUCCESS,
  LOAD_APPLICATIONS_BY_ACCOUNT_SUCCESS,
  LOAD_APPLICATIONS_BY_ACCOUNT_FAILURE,
  LOAD_APPLICATIONS_FAILURE,
  LOAD_APPLICATIONS_SUCCESS,
  UPLOAD_APPLICATION_SUCCESS,
} from "./actions";

const apiApplicationReducer = getApiReducer(
  LOAD_APPLICATIONS_SUCCESS,
  LOAD_APPLICATIONS_FAILURE,
);

const apiAccountApplicationsReducer = getApiReducer(
  LOAD_APPLICATIONS_BY_ACCOUNT_SUCCESS,
  LOAD_APPLICATIONS_BY_ACCOUNT_FAILURE,
);

function compatReducer(state, action) {
  // TODO(jhohman): Remove once we build out correct application logic for
  //   all views to handle available and unavailable apps.
  const { type } = action;

  switch (type) {
    case LOAD_APPLICATIONS_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        allApps: reduceById({}, state.data),
        byId: reduceById(
          {},
          state.data.filter((app) => app.available),
        ),
        data: state.data.filter((app) => app.available),
      };
    default:
      return state;
  }
}

function extraReducer(state, action) {
  const { type, payload = {} } = action;
  const { data: application } = payload;

  switch (type) {
    case EDIT_APPLICATION_SUCCESS:
      return {
        ...state,
        byId: updateById(state.byId, application),
      };
    case UPLOAD_APPLICATION_SUCCESS:
      return {
        ...state,
        byId: reduceById(state.byId, [application]),
      };
    default:
      return state;
  }
}

const applicationReducer = reduceReducers(
  apiApplicationReducer,
  apiAccountApplicationsReducer,
  extraReducer,
  compatReducer,
);

export { applicationReducer, extraReducer };
